"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskController = void 0;
const APIErrors_1 = require("./resources/APIErrors");
const APITasks_1 = require("./resources/APITasks");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const LogLevel_1 = require("./LogLevel");
class TaskController {
    constructor(classInit, name) {
        this.classInit = classInit;
        this.name = name;
        this.userDecisions = {};
        this.client = classInit.client;
        this.com = classInit.com;
        this.idleTask = this.com.taskSupplier.get(APITasks_1.APITasks.idle);
    }
    reset() {
        this.currentTask = undefined;
        this.resetUserDecisions();
    }
    resetSubTask() {
        if (this.currentTask) {
            this.currentTask.setSubTaskInstance(undefined);
        }
    }
    log(level, msg) {
        this.com.log(level, "(" + this.name + ") " + msg);
    }
    logTask(level, mainDef, mainContent = [], subDef, subContent) {
        if (level >= this.com.getLogLevel()) {
            const task = this.com.taskSupplier.get(mainDef, mainContent, subDef, subContent);
            this.log(level, task.getMessage());
        }
    }
    error(err, prefix = "", task) {
        if (this.com.getLogLevel() < LogLevel_1.LogLevel.none) {
            if (!err.loggedAPI) {
                err.loggedAPI = true;
                let msg;
                msg = (err.getMessage) ? err.getMessage() : err.message;
                if (task) {
                    msg = task.getMessage() + msg;
                }
                if (prefix) {
                    msg = prefix + msg;
                }
                this.log(LogLevel_1.LogLevel.error, msg);
            }
        }
    }
    errorNative(err) {
        this.error(this.com.err.get(APIErrors_1.APIErrors.anyError, [err.message]));
    }
    getCurrentTask() {
        return this.currentTask || this.idleTask;
    }
    setCurrentTask(level, mainDef, mainContent = [], subDef, subContent = []) {
        const task = this.com.taskSupplier.get(mainDef, mainContent, subDef, subContent);
        if (this.currentTask) {
            this.currentTask.setSubTaskInstance(task);
        }
        else {
            this.currentTask = task;
        }
        this.log(level, this.currentTask.getMessage());
        return task;
    }
    setCurrentSubTask(level, subDef, subContent = []) {
        const task = (subDef) ? this.com.taskSupplier.get(subDef, subContent) : this.com.taskSupplier.get(APITasks_1.APITasks.idle);
        if (this.currentTask) {
            this.currentTask.setSubTaskInstance(task);
            this.log(level, this.currentTask.getMessage());
        }
        return task;
    }
    getErrorPromise(mainDef, mainContent = [], subDef, subContent) {
        const msg = (this.currentTask) ? this.currentTask.getMessage() : "unknown";
        const self = this;
        const e = this.com.err.get(mainDef, mainContent, subDef, subContent);
        return new Promise((resolve, reject) => {
            self.onPromiseError(msg, e);
            return reject(e);
        });
    }
    updateTaskProgress(prg) {
        prg.percent = (prg.length === 0) ? 100 : prg.pos / prg.length * 100;
        prg.timeElapsed = FSIServerClientUtils_1.FSIServerClientUtils.NOW() - prg.timeStart;
    }
    onStepProgress(level, options, apiTaskDef, content, pos = 0, length = 0) {
        if (options._taskProgress) {
            options._taskProgress.logLevel = level;
            const prg = options._taskProgress;
            prg.currentTask = this.com.taskSupplier.get(apiTaskDef, content);
            prg.pos = pos;
            prg.length = length;
            this.updateTaskProgress(options._taskProgress);
            if (prg.bytesDone > 0 && prg.timeElapsed > 0) {
                prg.bytesPerSecond = prg.bytesDone / prg.timeElapsed * 1000;
            }
            if (options._fnQueueProgress !== undefined) {
                options._fnQueueProgress.fn.call(options._fnQueueProgress.ctx, options._taskProgress);
            }
            else if (options.fnProgress !== undefined) {
                options.fnProgress.fn.call(options.fnProgress.ctx, options._taskProgress);
            }
        }
        else if (level > -1) {
            const subTask = this.getCurrentTask().getSubTaskInstance();
            this.setCurrentSubTask(LogLevel_1.LogLevel.debug, apiTaskDef, content);
            this.getCurrentTask().setSubTaskInstance(subTask);
        }
    }
    onPromiseError(msg, error) {
        if (error.message)
            msg += " -> " + error.message;
        this.log(LogLevel_1.LogLevel.error, "ERROR: " + msg);
    }
    onPromiseOk() {
        if (this.currentTask) {
            this.log(LogLevel_1.LogLevel.trace, "DONE: " + this.currentTask.getMessage());
        }
    }
    resetUserDecisions() {
        this.userDecisions = {};
    }
    getUserDecision(keys) {
        return this.userDecisions[keys];
    }
    evaluateDecision(promptReply) {
        const r = promptReply.reply;
        if (r.match(/All$/i)) {
            promptReply.replyAll = promptReply.reply = r.replace(/All$/i, "");
        }
        else if (r === "always") {
            promptReply.replyAll = promptReply.reply = "yes";
        }
        if (promptReply.replyAll) {
            this.userDecisions[promptReply.errKeys] = promptReply;
        }
    }
    wrapPromise(p) {
        const msg = (this.currentTask) ? this.currentTask.getMessage() : "unknown";
        return p.then(arg => {
            this.onPromiseOk();
            return arg;
        })
            .catch(error => {
            this.onPromiseError(msg, error);
            throw error;
        });
    }
}
exports.TaskController = TaskController;
